<div class="main-modal" [formGroup]="_form" [ngClass]="{'submitted': _isSubmitted === true}" (ngSubmit)="onSubmit()"
    autocomplete="off" novalidate>
    <div class="modal_header">

        <h2 class="modal_title">Assign Truck <span class="f-12 fw-400 text-grey-light">(LYNK ID#: {{data.lynk}})</span>
        </h2>
        <div class="material-icons close_modal" (click)="close()">close</div>
    </div>

    <div mat-dialog-content class="modal-body">
        <div class="mb-0 mt-3">
            <div class="form_row " *ngIf="data.autoHire">
                <span class="px-3 label-badge m-0 fw-500 green_text">Bid Price:
                    {{data.targetPrice}}</span>
            </div>
            <div class="form_row">
                <label class="label mb-2">Select Truck</label>
                <div class="input_block select-border-box-outer">
                    <mat-form-field class="w-100">
                        <mat-select placeholder="Select Truck" class="select-border-box input_fld" formControlName="truckId">
                            <mat-option *ngFor="let iTruck of _truckList" [value]="iTruck.id">
                                {{iTruck.mcNumber}}
                            </mat-option>

                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="red_text" *ngIf="_form.get('truckId')?.invalid && (_form.get('truckId')?.touched || _isSubmitted)">
                  <div *ngIf="_form.get('truckId')?.hasError('required')">Truck is required.</div>
                </div>
            </div>

            <div class="form_row">
                <label class="label mb-2">Select Trailer</label>
                <div class="input_block select-border-box-outer">
                    <mat-form-field class="w-100">
                        <mat-select placeholder="Select Trailer" class="select-border-box input_fld"
                            [class.has-error]="showMessage"
                            formControlName="trailerId">
                            <mat-option *ngFor="let iTrailer of _trailerList" [value]="iTrailer.id">
                                {{iTrailer.trailerNumber}}
                            </mat-option>

                        </mat-select>
                    </mat-form-field>
                </div>
                                <div class="red_text error-msg" *ngIf="_form.get('trailerId')?.invalid && !showMessage && (_form.get('trailerId')?.touched || _isSubmitted)">
                  <div *ngIf="_form.get('trailerId')?.hasError('required')">Trailer is required.</div>
                </div>
                                <div class="red_text error-msg mb-2" *ngIf="showMessage">No trailers are available for the selected requirements.</div>
            </div>
            <div class="form_row">
                <label class="label mb-2">Select Driver</label>
                <div class="input_block">
                    <div class="input_hover input-border input-border-with-icon">
                        <mat-form-field class="w-100" appearance="fill">
                            <div class="input-icon-front"><span class="material-icons green_text">search</span></div>

                            <input class="input_fld" matInput placeholder="Select Driver" formControlName="driverId"
                                [matAutocomplete]="autoCompleteDrivers">

                            <mat-autocomplete #autoCompleteDrivers="matAutocomplete">
                                <mat-option *ngFor="let iDriver of _driverList" [value]="iDriver.name"
                                    (click)="selectDriver(iDriver)">
                                    {{iDriver.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal-footer no-border">
        <button mat-button class="btn cancel_btn large_btn" (click)="close()">
            Cancel
        </button>
        <button mat-button class="btn  large_btn green_btn" (click)="onSubmit()">
            Submit
        </button>
    </div>
</div>